import { statusPageContentsStyles, sectionHeaderStyles } from 'app/components/presentation/text/styles';
import React, { FunctionComponent, ReactNode } from 'react';
import { useClasses } from 'app/utils/css';
import MarginGroup from 'app/components/layout/MarginGroup';
import PageWidth from 'app/components/presentation/containers/page/PageWidth';

interface IProps {
  image: ReactNode;
  header: ReactNode;
  message: ReactNode;
  buttons: ReactNode;
}

const OwlMessagePage: FunctionComponent<IProps> = ({ image, header, message, buttons }) => {
  const classes = useClasses({
    centerContent: {
      display: 'flex',
      justifyContent: 'center',
    },
    headerText: sectionHeaderStyles,
    owlImage: {
      margin: 'auto',
      width: '100%',
      maxWidth: '400px',
      textAlign: 'center',
    },
    pageContent: {
      paddingTop: '4em',
      paddingBottom: '4em',
    },
    pageContentText: {
      ...statusPageContentsStyles,
      textAlign: 'center',
      padding: '0 0.5em',
    },
  });

  return (
    <PageWidth maxWidth="792px">
      <div className={classes.pageContent}>
        <MarginGroup margin={'15px'}>
          <div className={classes.owlImage}>
            {image}
          </div>
          <div className={classes.centerContent}>
            <div className={classes.headerText}>
              {header}
            </div>
          </div>
          <div className={classes.centerContent}>
            <div className={classes.pageContentText}>
              {message}
            </div>
          </div>
          <div className={classes.centerContent}>
            {buttons}
          </div>
        </MarginGroup>
      </div>
    </PageWidth>
  );
};

export default OwlMessagePage;
